<template>
<div :class="['callout', calloutClass]" aria-live="polite" role="alert">
    <!-- if no icon just show slot -->
    <slot v-if="noIcon"></slot>
    <!-- else show both -->
    <div v-else class="d-flex justify-content-start">
        <b-icon :icon="icon" :font-scale="1.5" class="mr-3 align-self-center"/>
        <div>
            <slot></slot>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "Callout",
    props: {
        // disables icon if set
        noIcon: {
            default: false,
            type: Boolean,
            required: false
        },
        // specifies class of callout that should be used
        calloutClass: {
            default: 'callout-info',
            type: String,
            required: false
        },
        // bootstrap-icon to be used
        icon: {
            default: 'exclamation-circle',
            type: String,
            required: false
        }
    }
}
</script>

<style scoped>

</style>
